export default __webpack_public_path__ + "static/referral.url-62e75591574f3ee23c4f2f8a4f7699ac.svg";